module.exports = __webpack_public_path__ + "static/media/mistmaker_off.988c35fe.png";